var _path, _path2, _path3, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCartOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72729 3H4.5585C5.25422 3 5.60209 3 5.86397 3.18876C6.12586 3.37752 6.23586 3.70753 6.45587 4.36754L7.09093 6.27273",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.1818H7.6919C7.41945 17.1818 7.28322 17.1818 7.18125 17.1604C6.67625 17.054 6.33517 16.5807 6.39393 16.068C6.40579 15.9645 6.44887 15.8352 6.53502 15.5768V15.5768C6.63065 15.2899 6.67847 15.1464 6.73926 15.0234C7.03295 14.4288 7.60225 14.0185 8.25918 13.9279C8.39516 13.9091 8.54636 13.9091 8.84877 13.9091H14.7273",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5878 13.9091H10.8194C9.54015 13.9091 8.90054 13.9091 8.3996 13.5788C7.89866 13.2485 7.6467 12.6606 7.14279 11.4848L6.70124 10.4545C5.89174 8.56567 5.487 7.62126 5.9316 6.947C6.37621 6.27274 7.4037 6.27274 9.45867 6.27274H16.1032C18.4022 6.27274 19.5517 6.27274 19.9853 7.01985C20.4189 7.76696 19.8485 8.76502 18.7079 10.7612L18.0607 11.8937C17.4988 12.877 17.2178 13.3687 16.7523 13.6389C16.2867 13.9091 15.7204 13.9091 14.5878 13.9091Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4546,
    cy: 19.9091,
    rx: 1.09091,
    ry: 1.09091,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.72726,
    cy: 19.9091,
    rx: 1.09091,
    ry: 1.09091,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartOff);
export default __webpack_public_path__ + "static/media/icon_cart_off.748b5a2062c148642a83e386ff1f5061.svg";
export { ForwardRef as ReactComponent };